module.exports = __webpack_public_path__ + "img/webIcon.3f3f92bf.jpg";